/** 底部导航点击时通知当前页拉取最新数据（含再次点击同一 Tab） */
export const AIMATCH_TAB_ACTIVATE = 'aimatch:tab-activate';
